/* istanbul ignore file: This file is mostly integration with the Google API */
'use strict';

customerZone

/**
 * Displays a google map
 */
.component('googleMap', {
    bindings: {
        initial: '@',
        locations: '<',
        selection: '='
    },
    templateUrl: customerZone.fromBase('components/google-map/google-map.component.html'),
    controller: ['$q', '$log', '$scope', '$element', 'errorCode', 'utils', function($q, $log, $scope, $element,
                                                                                    errorCode, utils) {
        var vm = this;

        /*
         * Note: google seems to have issues with relative urls here.  So we're hardcoding public icons
         * for this until a better solution comes around.
         */
        var ICON_WITH_LABEL = {
            url: 'https://s3-eu-west-1.amazonaws.com/ire-s3-prod-unl-jim-web/content/uploads/2017/11/10140818/' +
            'pin_empty.png',
            size: new google.maps.Size(23, 26),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(12, 24),
            labelOrigin: new google.maps.Point(12, 12)
        };
        var ICON_WITHOUT_LABEL = {
            url: 'https://s3-eu-west-1.amazonaws.com/ire-s3-prod-unl-jim-web/content/uploads/2017/11/10144550/' +
            'pin_logo.png',
            size: new google.maps.Size(23, 26),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(12, 24),
            labelOrigin: new google.maps.Point(12, 12)
        };

        var map, markerClusterer;

        var loadAddress = function(address){
            var deferred = $q.defer();
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({address: address}, function (results, state) {
                if (state === google.maps.GeocoderStatus.OK && results.length > 0)
                    deferred.resolve(results[0]);
                else
                    deferred.reject();
            });
            return deferred.promise;
        };

        vm.$onInit = function() {
            map = new google.maps.Map($element.find('.google-map')[0]);
            loadAddress(vm.initial).then(function(initial){
                map.setCenter(initial.geometry.location);
                map.fitBounds(initial.geometry.viewport);
            });
            markerClusterer = new MarkerClusterer(map, [], {
                minimumClusterSize: 10,
                maxZoom: 14,
                averageCenter: true
            });

            var markers = [];
            $scope.$watchCollection(function(){ return vm.locations; }, function(){
                markers.forEach(function(marker){
                    marker.setMap(null);
                });
                markers = [];
                var bounds = new google.maps.LatLngBounds();

                vm.locations.forEach(function(location){
                    var options = {
                        position: location.coordinates,
                        map: map,
                        title: location.name,
                        icon: ICON_WITHOUT_LABEL
                    };

                    if (location.label) {
                        options.label = {
                            text: location.label,
                            color: 'white',
                            fontFamily: 'MuseoSansRounded',
                            fontWeight: 'bold'
                        };
                        options.icon = ICON_WITH_LABEL;
                    }

                    var marker = new google.maps.Marker(options);
                    marker.location = location;
                    markers.push(marker);
                    marker.addListener('click', function(){
                        $scope.$apply(function(){
                            vm.selection = location;
                        });
                    });
                    bounds.extend(location.coordinates);

                });

                markerClusterer.clearMarkers();
                markerClusterer.addMarkers(markers, false);
                map.fitBounds(bounds);

            });

            $scope.$watch(function(){ return vm.selection; }, function() {
                markers.forEach(function(marker){
                    marker.setAnimation(vm.selection === marker.location ? google.maps.Animation.BOUNCE : null);
                });
                if (vm.selection && vm.selection.coordinates)
                    map.panTo(vm.selection.coordinates);
            });

        };


    }],
    controllerAs: 'vm'
});
